import styles from "./WeekendConfiguration.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoAddCircleOutline, IoCloseOutline } from "react-icons/io5";

const data = [
  {
    _id: "1",
    day: "Saturday",
    week1: false,
    week2: false,
    week3: false,
    week4: false,
    week5: false,
  },
  {
    _id: "2",
    day: "Sunday",
    week1: false,
    week2: false,
    week3: false,
    week4: false,
    week5: false,
  },
];
  

function WeekendConfiguration() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const initialDays = ["Saturday", "Sunday"];

  const [selectedDays, setSelectedDays] = useState(initialDays);
  const [weekendData, setWeekendData] = useState(
    initialDays.map((day, i) => ({
      _id: (i + 1).toString(),
      day,
      week1: false,
      week2: false,
      week3: false,
      week4: false,
      week5: false,
    }))
  );
  const handleRemoveDay = (dayToRemove) => {
    setSelectedDays((prevDays) =>
      prevDays.filter((day) => day !== dayToRemove)
    );
    setWeekendData((prevData) =>
      prevData.filter((item) => item.day !== dayToRemove)
    );
  };
  

  const handleSave = () => {
    console.log("Save clicked");
    // You can also log selected checkbox states or form data here
  };
  
  const handlecreateform = () => {
    dispatch(openModal("createForm"));
  };
  const getColumnData = (data) => {
    return data.map((item) => ({
        day: (
            <div className={styles.greyCol}>
              {item.day}
            </div>
          )
,          
      week1: (
        <input
          type="checkbox"
          checked={item.week1}
          onChange={() => toggleCheckbox(item._id, "week1")}
        />
      ),
      week2: (
        <input
          type="checkbox"
          checked={item.week2}
          onChange={() => toggleCheckbox(item._id, "week2")}
        />
      ),
      week3: (
        <input
          type="checkbox"
          checked={item.week3}
          onChange={() => toggleCheckbox(item._id, "week3")}
        />
      ),
      week4: (
        <input
          type="checkbox"
          checked={item.week4}
          onChange={() => toggleCheckbox(item._id, "week4")}
        />
      ),
      week5: (
        <input
          type="checkbox"
          checked={item.week5}
          onChange={() => toggleCheckbox(item._id, "week5")}
        />
      ),
    }));
  };
  
  const toggleCheckbox = (id, week) => {
    setWeekendData((prev) =>
      prev.map((item) =>
        item._id === id ? { ...item, [week]: !item[week] } : item
      )
    );
  };

  const displayData = getColumnData(weekendData);


  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    { title: "Selected days", accessor: "day" },
    { title: <span> 1st Week</span>, accessor: "week1" },
    { title: <span> 2nd Week</span>, accessor: "week2" },
    { title: <span> 3rd Week</span>, accessor: "week3" },
    { title: <span> 4th Week</span>, accessor: "week4" },
    { title: <span> 5th Week</span>, accessor: "week5" },
  ];
  
  

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.section}>
              <span>Configure Weekend Days</span>
              <div className={styles.recipientBox}>
                <div className={styles.toWrapper}>
                  {selectedDays.map((day, i) => (
                    <span key={i} className={styles.recipient}>
                      {day}
                      <IoCloseOutline
                        size={16}
                        onClick={() => handleRemoveDay(day)}
                        className={styles.removeIcon}
                      />
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
          <div className={styles.saveButtonWrapper}>
            <button className={styles.saveButton} onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeekendConfiguration;
